import selectdevtools from "../../../../assets/images/docs/select-devtools.png";
import { Code } from 'react-bytesize-icons';
import * as React from 'react';
export default {
  selectdevtools,
  Code,
  React
};